module.exports = __webpack_public_path__ + "static/particle-top-left-71aaa31a4a6781deaab7714a6a76fa42.png";